var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2552 11.9131L12.4127 13.7619C11.6655 14.5117 10.3508 14.5279 9.58746 13.7619L7.74483 11.9131L1.12695 18.5525C1.37329 18.6664 1.6449 18.7344 1.93365 18.7344H20.0665C20.3552 18.7344 20.6267 18.6665 20.873 18.5525L14.2552 11.9131Z",
    fill: "#4A60AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 3.26562H1.93356C1.64481 3.26562 1.37321 3.3336 1.12695 3.44751L8.19862 10.5426C8.19909 10.5431 8.19965 10.5432 8.20012 10.5437C8.2006 10.5441 8.20068 10.5448 8.20068 10.5448L10.5001 12.8518C10.7443 13.096 11.2557 13.096 11.5 12.8518L13.7989 10.5452C13.7989 10.5452 13.7994 10.5441 13.7999 10.5437C13.7999 10.5437 13.8009 10.5431 13.8014 10.5426L20.8729 3.44747C20.6266 3.33352 20.3551 3.26562 20.0664 3.26562Z",
    fill: "#4A60AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.205648 4.34895C0.0782031 4.60668 0 4.89277 0 5.19922V16.8008C0 17.1072 0.0781172 17.3933 0.205605 17.651L6.83495 11.0002L0.205648 4.34895Z",
    fill: "#4A60AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7943 4.34887L15.165 11.0002L21.7943 17.6511C21.9217 17.3934 21.9999 17.1073 21.9999 16.8008V5.19922C21.9999 4.89268 21.9217 4.6066 21.7943 4.34887Z",
    fill: "#4A60AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.15391caa4a222e749b1c288cc616415f.svg";
export { ForwardRef as ReactComponent };